import assign from 'lodash/assign';
import platformUtils from 'platformUtils';

const VIDEO_URL_REGEX = /^wix:video:\/\/v1\/([^\/]+)\/([^\/]+)\/#posterUri=([^\/]+)&posterWidth=([0-9]+)&posterHeight=([0-9]+)/;

function buildFullUrlFromMediaRef(mediaRef) {
    if(!mediaRef.videoId){
        return null;
    }
    return `wix:video://v1/${getVideoId(mediaRef.videoId)}/${mediaRef.fileName}/#posterUri=${mediaRef.posterImageRef.uri}&posterWidth=${mediaRef.posterImageRef.width}&posterHeight=${mediaRef.posterImageRef.height}`;
}

function extractModelDataFromSrc(src) {
    if (VIDEO_URL_REGEX.test(src)) {
        const backgroundUtils = platformUtils.getBackgroundUtils();
        const [, videoUri, fileName, posterUri, posterWidth, posterHeight] = src.match(VIDEO_URL_REGEX) || [0, src];
        return assign(backgroundUtils.getVideoPosterObject(videoUri, posterUri, parseInt(posterWidth, 10), parseInt(posterHeight, 10)), {fileName});
    }
    return null;
}

function getVideoId(videoId){
 return videoId.replace('video/', '');
}

function isVideoUrl(src){
    return VIDEO_URL_REGEX.test(src);
}

function getFullVideoData(videoId, callback){
    videoId = getVideoId(videoId);
    const VIDEO_INFO_END_POINT = `https://files.wix.com/files/${videoId}/info`;
    fetch(VIDEO_INFO_END_POINT)
        .then((response) => response.json())
        .then((response) => {
            const backgroundUtils = platformUtils.getBackgroundUtils();
            const fullVideoMediaRef = backgroundUtils.getVideoBackgroundObject(response, {});
            callback(fullVideoMediaRef);
          });
}




export default {
    buildFullUrlFromMediaRef,
    isVideoUrl,
    extractModelDataFromSrc,
    getFullVideoData
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils/videoUtils.es6